/* eslint-disable */

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { logoutUser } from "../../core/redux/authActions";
import ThemeToggle from "../../feature-module/components/ThemeToggle";
import { all_routes } from "../../Router/all_routes";

const Header = () => {
  const { userRole, fullName } = useSelector((state) => state.auth);
  const route = all_routes;
  const dispatch = useDispatch();
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };
  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []);
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
      );
    };

    console.log(fullName);

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };
  const { expandMenus } = useSelector(
    (state) => state.themeSetting.expandMenus
  );
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const logoutfunction = async () => {
    try {
      // Dispatch logout
      await dispatch(logoutUser());

      // Verify logout worked (optional debugging)
      const token = localStorage.getItem("accessToken");
      if (token) {
        console.warn("Token still exists, forcing logout");
        dispatch(forceLogout());
      }

      // Navigate to login page or home
      // window.location.href = '/login'; // or use your router
    } catch (error) {
      alert("Logout failed:", error);
    }
  };

  return (
    <>
      <div className="header">
        {/* Logo */}
        <div className="main-header">
          <div
            className={`header-left
             ${toggle ? "" : "active"}
             ${
               expandMenus || dataLayout === "layout-hovered"
                 ? "expand-menu"
                 : ""
             }
             justify-between `}
            onMouseLeave={expandMenu}
            onMouseOver={expandMenuOpen}
          >
            <Link to="/dashboard" className="logo logo-normal !w-fit">
              <img
                src={`${process.env.REACT_APP_SITE_URL}${process.env.REACT_APP_WEBSITE_LOGO}`}
                alt="img"
                className="mx-3 h-12 object-contain"
              />
            </Link>
          </div>
          {/* /Logo */}
          <Link
            id="mobile_btn"
            className="mobile_btn"
            to="#"
            onClick={sidebarOverlay}
          >
            <span className="bar-icon">
              <span />
              <span />
              <span />
            </span>
          </Link>

          {/* Main Screen Menu */}
          {/* Header Menu */}
          <ul className="nav user-menu ss">
            {/* Search */}
            <li className="nav-item nav-searchinputs">
              <div className="top-nav-search"></div>
            </li>
            <li className="nav-item pos-nav">
              <Link
                to={route.pos}
                target="_blank"
                className="btn btn-primary btn-md d-inline-flex align-items-center"
              >
                <i className="ti ti-device-laptop me-1" />
                POS
              </Link>
            </li>

            {/* Notifications */}
            {/* <li className="nav-item dropdown nav-item-box">
              <Link
                to="#"
                className="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
              >
                {/* <i data-feather="bell" />  */}
            {/* <div style={{ position: "relative" }}>
                  <i className="ti ti-bell"></i>
                  {localStorage.getItem("all_unread_count") > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: -5,
                        right: -6,
                        background: "red",
                        color: "white",
                        fontSize: "10px",
                        padding: "2px 6px",
                        borderRadius: "50%",
                        lineHeight: 1,
                      }}
                    >
                      {localStorage.getItem("all_unread_count")}
                    </span>
                  )}
                </div> */}

            {/* <span className="badge rounded-pill">2</span> */}
            {/* </Link> */}
            {/* <div className="dropdown-menu notifications">
                <div className="topnav-dropdown-header">
                  <h5 className="notification-title">Notifications</h5>
                  <Link to="#" className="clear-noti">
                    Mark all as read
                  </Link>
                </div>
                <div className="noti-content">
                  <ul className="notification-list">
                    <Notification />
                  </ul>
                </div>
                <div className="topnav-dropdown-footer d-flex align-items-center gap-3">
                  <Link to="#" className="btn btn-secondary me-3 me-3 me-3 btn-md w-100">
                    Cancel
                  </Link>
                  <Link
                    to={route.activities}
                    className="btn btn-primary btn-md w-100"
                  >
                    View all
                  </Link>
                </div>
              </div> */}
            {/* </li> */}
            {/* <li className="nav-item">
              <ThemeToggle />
            </li> */}
            {/* /Profile */}
            <li className="nav-item dropdown has-arrow main-drop profile-nav">
              <Link
                to="#"
                className="nav-link userset"
                data-bs-toggle="dropdown"
              >
                <span className="user-info p-0">
                  <span className="user-letter">
                    <ImageWithBasePath
                      src={`${process.env.REACT_APP_WEBSITE_LOGO}`}
                      alt="Img"
                      className="img-fluid"
                    />
                  </span>
                </span>
              </Link>
              <div className="dropdown-menu menu-drop-user">
                <div className="profileset d-flex align-items-center">
                  <span className="user-img me-2">
                    <ImageWithBasePath
                      src={`${process.env.REACT_APP_WEBSITE_LOGO}`}
                      alt="Img"
                    />
                  </span>
                  <div>
                    <h6 className="fw-medium">{fullName}</h6>
                    <p>{userRole}</p>
                  </div>
                </div>
                <Link className="dropdown-item" to={route.profile}>
                  <i className="ti ti-user-circle me-2" />
                  MyProfile
                </Link>
                <Link className="dropdown-item" to={route.salesreport}>
                  <i className="ti ti-file-text me-2" />
                  Reports
                </Link>
                {/* <Link className="dropdown-item" to={route.generalsettings}>
                  <i className="ti ti-settings-2 me-2" />
                  Settings
                </Link> */}
                <hr className="my-2" />
                <button
                  className="dropdown-item logout pb-0"
                  onClick={logoutfunction}
                >
                  <i className="ti ti-logout me-2" />
                  Logout
                </button>
              </div>
            </li>
          </ul>

          {/* /Header Menu */}
          {/* Mobile Menu */}
          <div className="dropdown mobile-user-menu md:!hidden !flex  p-0 !pr-4">
            {/* <Link className="mr-4" to="/activities">
              <div style={{ position: "relative" }}>
                <i className="ti ti-bell"></i>
                {localStorage.getItem("all_unread_count") > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: -5,
                      right: -6,
                      background: "red",
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "50%",
                      lineHeight: 1,
                    }}
                  >
                    {localStorage.getItem("all_unread_count")}
                  </span>
                )}
              </div>
            </Link> */}
            {/* <ThemeToggle /> */}
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link className="dropdown-item" to="profile">
                My Profile
              </Link>
              <Link className="dropdown-item">
                <button onClick={logoutfunction}>Logout</button>
              </Link>
            </div>
          </div>

          {/* /Mobile Menu */}
        </div>
      </div>
    </>
  );
};

export default Header;
